// extracted by mini-css-extract-plugin
module.exports = {"countdown-box":"rule-detail_countdown-box__o06sb","pre-rate":"rule-detail_pre-rate__mnTcg","temp-rate":"rule-detail_temp-rate__Kho1n"};